import clsx from 'clsx'
import { Icon } from '@iconify/react'
import MyAvatar from 'src/components/MyAvatar'
import React, { useRef, useState, useEffect } from 'react'
import PopoverMenu from 'src/components/PopoverMenu'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Divider, MenuItem, Typography } from '@material-ui/core'
import { MIconButton } from 'src/theme'
import { authenticationLogoutAction } from 'src/reducers/authentication/action'
import translator from 'src/translate'
import { CoreButton } from 'src/components/core'
import { meService } from 'src/api/authentication'
import { useDispatch } from 'react-redux'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import Knowup from 'src/components/knowup'
import { useHistory } from 'react-router-dom'
// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'My Account',
    linkTo: '/profile',
    target: '_self',
  },
  {
    label: 'Custom Domain',
    linkTo: '/custom-domain',
    target: '_self',
  },
  {
    label: 'Automations',
    linkTo: '/automations',
    target: '_self',
  },
  {
    label: 'Help center',
    linkTo: 'https://intercom.help/mini-course-generator/en/',
    target: '_blank',
  },
  /*   {
    label: 'KnowUp',
    icon: 'lets-icons:external',
    linkTo: '/other-products',
    target: '_self',
  }, */
]

const useStyles = makeStyles(theme => ({
  btnAvatar: {
    padding: 0,
    width: 44,
    height: 44,
  },
  isSelected: {
    '&:before': {
      zIndex: 1,
      content: "''",
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      position: 'absolute',
    },
  },
}))

// ----------------------------------------------------------------------

function Account(props) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const history = useHistory()
  const anchorRef = useRef(null)
  const [isOpen, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = option => {
    if (option.label == 'KnowUp') {
      dispatch(
        messageBoxShowAction(
          MessageBoxContent({
            type: MessageBoxType.INFO,
            buttons: [],
            title: 'Our other product',
            component: <Knowup />,
            maxWidth: '800px',
          }),
        ),
      )
    } else if (option.label == 'Help center') {
      window.open(option.linkTo, '_blank')
    } else {
      history.push(option.linkTo)
    }
    setOpen(false)
  }
  const handleLogoutOpenPopup = e => {
    dispatch(authenticationLogoutAction())
  }

  const [user, setUser] = useState(window.CONSTANTS.NAME)
  const [surName, setSurName] = useState(window.CONSTANTS.SUR_NAME || '')
  const [companyName, setCompanyName] = useState(
    window.CONSTANTS.COMPANY_NAME || '',
  )
  useEffect(() => {
    meService().then(res => {
      setUser(res.data.name)
      setSurName(res.data.surname || '')
      setCompanyName(res.data.companyName || '')
    })
  }, [])
  const firstCharsAtName = user?.charAt(0) + surName?.charAt(0)

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        className={clsx(classes.btnAvatar, { [classes.isSelected]: isOpen })}
      >
        <MyAvatar text={firstCharsAtName} />
      </MIconButton>

      <PopoverMenu
        width={220}
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorRef.current}
      >
        <Box sx={{ my: 2, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {companyName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user} {surName}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map(option => (
          <MenuItem
            key={option.label}
            onClick={() => handleClose(option)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: option.label == 'KnowUp' ? '#5865F2' : 'inherit',
            }}
          >
            <Typography fontSize="14px" fontWeight={400}>
              {option.label}
            </Typography>
            {option.icon && (
              <Icon
                icon={option.icon}
                style={{
                  width: '20px',
                  height: '20px',
                  color: option.label == 'KnowUp' ? '#5865F2' : 'inherit',
                }}
              />
            )}
          </MenuItem>
        ))}
        <Divider sx={{ mt: 1 }} />

        <Box sx={{ p: 1 }}>
          <CoreButton
            fullWidth
            color="secondary"
            variant="text"
            onClick={handleLogoutOpenPopup}
          >
            {translator._('loginPage.logout')}
          </CoreButton>
        </Box>
      </PopoverMenu>
    </>
  )
}

export default Account
